import { useState, useEffect } from 'react';
import { getInstructorLists } from '../api/instructor';

const useInstructorLists = (storeId, instructorId, isSchedule, isWork) => {
  const [instructorList, setInstructorList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (storeId) {
          const data = await getInstructorLists({storeId, instructorId, isSchedule, isWork});
          setInstructorList(data);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [storeId, instructorId, isSchedule, isWork]);

  return { instructorList, loading, error };
};

export default useInstructorLists;
